import React from 'react';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';
import GridFormDefaultActions from '../grid_form/constants/grid_form_default_actions';
import Grid from 'realize_overrides/components/grid/grid';
import { Button } from 'realize/components/button';
import { forwardPropsToState } from 'utils/react_utils';
import ScreenSizes from 'screen_sizes';
import { connectToStore } from 'reflux/decorators/connect_to_store.js';
import { GridFormActions, GridFormStore } from '../grid_form/reflux/grid_form_store';
import { FormEvents, FormEventHandler } from 'form/events/form_event_handler';
import GridFormActionIds from '../grid_form/constants/grid_form_action_ids';
import { FormAPI } from 'lecom-api';
import { ModalActions } from "realize/stores/modal_store";
import { generateUUID } from 'utils/uuid';
import TableCellRenderFactory from 'grid/table_cell_render_factory';
import { DocumentActions } from '../document/reflux/document_store';

@connectToStore(GridFormStore, { storeIdProp: 'name' })
@mixin.decorate(window.CssClassMixin)
@forwardPropsToState([
	{ prop: 'waitingForAction' },
	{ prop: 'formAction' },
	{ prop: 'selectedDataRow' },
	{ prop: 'selectedRowId' },
	{ prop: 'dataRows' },
	{ prop: 'totalCount' },
	{ prop: 'initialValues' },
	{ prop: 'updateUUID' }
])

export default class GridContainer extends React.Component {
    static propTypes = {
		waitingForAction: PropTypes.bool,
		clientSide: PropTypes.bool,
		clientSideIdField: PropTypes.string,
        actions: PropTypes.array,
		data: PropTypes.object,
		createButton: PropTypes.object,
		updateButton: PropTypes.object,
		cancelButton: PropTypes.object,
		actionButtons: PropTypes.object
	};

	static defaultProps = {
		waitingForAction: false,
        clientSide: true,
        clientSideIdField: 'id',
		actions: GridFormDefaultActions,
        data: {dataRows: []},
		createButton: {name: 'actions.add', icon: 'add'},
		updateButton: {name: 'actions.update', icon: 'edit'},
		cancelButton: {name: 'actions.cancel', style: 'cancel'},
		actionButtons: {member: [], collection: []},
    };

    state = {
		waitingForAction: false,
		formAction: 'create',
		selectedDataRow: null,
		selectedRowId: null,
		dataRows: (this.props.data.dataRows || []),
		totalCount: 0,
		updateUUID: '',
		lengthDataRow: false
	};

	constructor(props) {
		super(props);

		/*BINDS*/
		this.handleSubmitButtonClick = this.handleSubmitButtonClick.bind(this);
		this.submitFormFields = this.submitFormFields.bind(this);
		this.editAction = this.editAction.bind(this);
		this.handleResetButtonClick = this.handleResetButtonClick.bind(this);

		/*INIT ACTIONS BUTTON*/
		this.createButton = this.props.actions.find(a => a.id === GridFormActionIds.CREATE);
		this.updateButton = this.props.actions.find(a => a.id === GridFormActionIds.UPDATE);
		this.cancelButton = this.props.actions.find(a => a.id === GridFormActionIds.CANCEL);
	}

	/*CICLO DE VIDA REACT*/
	componentDidMount() {
		const formApi = FormAPI.form(this.props.formId);

		GridFormActions.loadInitialValues(formApi.initialValues(), this.props.id);
		this.tabOrder(this.props.id);

		setTimeout(() => {
			let destroyLineVisible = $('.destroy-line-grid').is(':visible');

			if(destroyLineVisible === true){
				let line = $('.destroy-line-grid');
				line.on('focus', (e) => {
					this.actionButtonDestroyTab();
				})
			}
		}, 1000);


		setTimeout(() => {
			this.parseColumnsProp();
			this.forceUpdate();
		}, 1500)
	}

	componentDidUpdate(){
		if(this.state.lengthDataRow === true){
			const fieldAPI = this.getFieldAPI();
			let idFirstFieldGrid = this.props.fields[0].id;
			fieldAPI.fields(idFirstFieldGrid).focus();
		}

		let dataRows = this.state.dataRows ? true : false
		if(dataRows === true){
			setTimeout(() => {
				this.actionsButtonsGridTab();
				// this.forceUpdate();
			}, 500);
		}
	}

	actionsButtonsGridTab(){
		let firstButton = $('.grid__table table tbody .button--flat').first().length !== 0 && $('.grid__table table tbody .button--flat').first();

		if(firstButton !== false){
			let classNameButton = firstButton[0].className ? firstButton[0].className : false;
			let editLine = classNameButton.includes('edit-line-grid');
			let destroyLine = classNameButton.includes('destroy-line-grid');


			if(editLine === false && destroyLine === false){
				let customId = firstButton[0].id;
				let buttons = $(`tbody #${customId}`);

				buttons.unbind('keypress').keypress((e) => {
					e.which === 13 && e.currentTarget.click()
				});
			}
		}
	}

	actionButtonDestroyTab(){
		let buttonDestroy = $('.destroy-line-grid');

		buttonDestroy.keypress(function(e) {
			if(e.which === 13){
				e.currentTarget.click();
				e.currentTarget.lastChild.focus();
			}
		});
	}

	tabOrder(id){
		let submitGrid = $(`#input__${id} .submit-button-grid`);

		submitGrid.unbind('click').on('click', () => {
			this.actionsButtonsGridTab();
		})
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (this.state.updateUUID !== nextState.updateUUID || this.props.readOnly !== nextProps.readOnly ) return true;
		return false;
	}

	/*UTILS*/
	getFieldAPI() {
		var form = FormAPI.form(this.props.formId);
		return form.fields(this.props.id);
	}

	loadGridData () {
		const gridRef = this.refs.grid;
		gridRef.loadData();
	}

	submitFormFields(event) {
		event.preventDefault();

		GridFormActions.submitDataRow(this.props.id);

		this.calculateWidthTD();
    }

    calculateWidthTD() {
            setTimeout(() => {
                $(".table-cell--text").each((key, e) => {
                    const maxValue = 400;
                    var len = $(e).find('span').text().length * 10;
                    if(len >= maxValue) {
                    	$(e).css({'min-width': maxValue + 'px'});
                    }else if(len > 10) {
                    	$(e).css({'min-width': len + 'px'});
                    }
                });
            }, 0);
    }

	openFormFieldsModal(event) {
		let modalId = this.props.id + "-modal";
		ModalActions.open({ modalId: modalId });
	}

	getActionButtons() {
		let objectReturn = {};
		let defaultActionButtons = this.getDefaultActionButtons();

		Object
			.keys(defaultActionButtons)
			.forEach(key => {
				objectReturn[key] = this.mergeActionButtonsProps(defaultActionButtons[key], []);
			});

		return objectReturn;
	}

	editAction(event, dataRowId, dataRow) {
		event.preventDefault();

		if (this.props.isMobile || window.innerWidth <= ScreenSizes.SMALL_SCREEN_WIDTH)
			ModalActions.open({ modalId: this.props.id + '-modal' });

		setTimeout(() => {
			const fieldAPI = this.getFieldAPI();
			let btnCancelGrid = $('.btn-grid-cancel');
			let idFirstFieldGrid = this.props.fields[0].id;

			btnCancelGrid.attr('tabindex', '0');

			btnCancelGrid.unbind('keypress').keypress(function(e) {
				if(e.which === 13)
					$('.btn-grid-cancel')[0].click();
			});

			btnCancelGrid.unbind('click').on('click', () => {
				fieldAPI.fields(idFirstFieldGrid).focus();
			})						
		}, 1000)

		const fieldDocument = this.props.fields.find(f => f.type === "DOCUMENT");

		if (fieldDocument) {
			DocumentActions.setValueInDocument(fieldDocument.id, "");
		}

		setTimeout(() => {			
			GridFormActions.editRow(this.props.id, dataRowId, dataRow);
		}, 0);
	}

	getDefaultActionButtons() {
		return {
			member: this.getDefaultMemberActionButtons(),
			collection: [],
		};
	}

	getDefaultMemberActionButtons() {
		if(this.props.readOnly || this.props.disabled) {
			return [];
		}

		return [
			this.getDefaultEditActionProps(),
			this.getDefaultDestroyActionProps()
		];
	}

	getDefaultEditActionProps() {
		const editButton = this.props.actions.find(a => a.id === GridFormActionIds.EDIT);
		const fieldAPI = this.getFieldAPI();

		return {
			...editButton,
			id: `${this.props.id}_edit`,
			'aria-label': Realize.i18n.t('general.button.edit'),
			role: 'button',
			onClick: (event, dataRowId, dataRow) => {

				const editNode = $(".edit-line-grid");
				let timeout = false;

				editNode.css({pointerEvents: "visible"});

				if(editNode.hasClass("edit-grid")) {
					timeout = true;
				}

				if(event && event.currentTarget && event.currentTarget.id) {
					this.handleResetButtonClick(event);					
					event.currentTarget.style.pointerEvents = "none";
					editNode.addClass("edit-grid");
				}

				if(document.getElementById('CANCEL')) {
					document.getElementById('CANCEL').click()
					setTimeout(() => {
						this.editAction(event, dataRowId, dataRow);
					}, 0)
					return
				}

				if(event.currentTarget.innerText === "mode_edit") {
					let idFirstFieldGrid = this.props.fields[0].id;
					fieldAPI.fields(idFirstFieldGrid).focus();
				}

				setTimeout(() => {
					this.editAction(event, dataRowId, dataRow);
				}, (timeout ? 100 : 0))
			},
			className: 'edit-line-grid'
		};
	}

	getDefaultDestroyActionProps() {
		const destroyButton = this.props.actions.find(a => a.id === GridFormActionIds.DESTROY);
		const fieldAPI = this.getFieldAPI();

		return {
			...destroyButton,
			id: 'destroy',
			'aria-label': Realize.i18n.t('template.actions.delete'),
			role: 'button',
			onClick: (event, id) => {
				this.executeDestroyAction(event, id);

				let dataRow = this.state.dataRows;
				if(dataRow.length === 1)
					this.state.lengthDataRow = true;
			},
			className: 'destroy-line-grid'
		};
	}

	executeDestroyAction (event, id) {
		event.preventDefault();

		GridFormActions.removeDataRow(this.props.name, id);

		const fieldAPI = this.getFieldAPI();
		fieldAPI.publish(FormEvents.GRID_DESTROY, this.props.name, id);
	}

	mergeActionButtonsProps(defaultButtonsProps, buttonsProps) {
		return defaultButtonsProps.concat(buttonsProps)
			.reduce((acc, currentProps) => {
				const repeatedPropsIndex = acc.findIndex((ap) => ap.id.toUpperCase() === currentProps.id.toUpperCase());

				(repeatedPropsIndex >= 0)
					? acc[repeatedPropsIndex] = Object.assign({}, acc[repeatedPropsIndex], currentProps)
					: acc.push(currentProps);

				return acc;
			} ,[])
			.filter((buttonProps) => !buttonProps.hidden);
	}

	getFormSubmitButton() {
		return (this.state.formAction === 'update' && (!this.props.isMobile && window.innerWidth > ScreenSizes.SMALL_SCREEN_WIDTH))
			? this.props.updateButton
			: this.props.createButton;
	}

	getFormOtherButtons() {
		if(this.state.formAction === 'update' && (!this.props.isMobile && window.innerWidth > ScreenSizes.SMALL_SCREEN_WIDTH)) {
			return [Object.assign({}, this.props.cancelButton, {
				type: "reset",
				onClick: this.handleResetButtonClick.bind(this, null, true),
				className: 'btn-grid-cancel'
			})];
		}

		return [];
	}

	parseColumnsProp() {
		const formApi = FormAPI.form(this.props.formId);

		let newColumns = [];
		let columnsObject = {};

		this.props.columns.forEach((col, index) => {			
			newColumns.push({
				component: col.component,
				format: col.format,
				label: formApi.fields(this.props.id).fields(col.name) ? formApi.fields(this.props.id).fields(col.name).label() : col.label,
				name: col.name,
				visible: col.visible,
				ruleRender: col.ruleRender
			})
		});

		for (let cont = 0, len = newColumns.length; cont < len; cont++) {
			let column = newColumns[cont];

			columnsObject[column.name] = Object.assign(column, {
				name: column.name,
				component: TableCellRenderFactory
			})
		}		

		return columnsObject;
	}

	/*HANDLERS*/
	handleFormReset (event) {
		$(".edit-line-grid").removeClass("edit-grid").css({pointerEvents: "visible"});		
		GridFormActions.reset(this.props.id);
	}

	handleSubmitButtonClick(event) {

		$(".edit-line-grid").removeClass("edit-grid").css({pointerEvents: "visible"});
		(!this.props.isMobile && window.innerWidth > ScreenSizes.SMALL_SCREEN_WIDTH)
			? this.submitFormFields(event)
			: this.openFormFieldsModal(event);
	}

	handleResetButtonClick(event, publishEvent) {
		$(".edit-line-grid").css({pointerEvents: "visible"});		
		GridFormActions.reset(this.props.id, publishEvent);
	};

	handleGridPagination({ page, perPage, dataRows }) {
		GridFormActions.loadNextPageData({ dataRows: dataRows, gridPage: page, gridPerPage: perPage }, this.props.name);
	}

	handleDestroySuccess(data, status, xhr) {
		this.loadGridData();
	}

	handleDestroyError(xhr, status, error) {
		this.setState({ waitingForAction: false });
		this.props.onDestroyError(xhr, status, error);
	}

	/*GET PROPS*/
    getGridProps () {
		const gridProps = Object.assign({}, this.propsWithoutCSS());
		gridProps.actionButtons = this.getActionButtons();
		gridProps.ref = "grid";
		gridProps.onPagination = this.handleGridPagination.bind(this);
		gridProps.columns = this.parseColumnsProp();
		gridProps.page = this.props.gridPage;
		gridProps.isLoading = this.state.waitingForAction;
		gridProps.readOnly = this.props.readOnly;
		gridProps.isMobile = this.props.isMobile;

		if (this.props.clientSide) {
			Object.assign(gridProps, {
				url: '',
				selectable: 'none',
				eagerLoad: false,
				dataRowIdField: this.props.clientSideIdField,
				data: {
					dataRows: this.state.dataRows,
					count: this.state.totalCount || (this.state.dataRows ? this.state.dataRows.length : 0)
				}
			});
		}

		return gridProps;
    }

	/*RENDERS*/
	renderOtherButtons() {
		const otherButtonsProps = this.getFormOtherButtons();
		const otherButtons = [];
		for (let i = 0; i < otherButtonsProps.length; i++) {
            const otherButtonProps = otherButtonsProps[i];

			if(otherButtonProps.hidden) continue;

			otherButtons.push(
				<Button
                    {...otherButtonProps}
					element="a"
					role='button'
                    disabled={otherButtonProps.disabled || this.state.waitingForAction}
                    key={otherButtonProps.name}
				/>
			);
		}

		return otherButtons;
	}

	renderSubmitButton() {
		const submitButton = this.getFormSubmitButton();

		if (!submitButton || submitButton.hidden || this.props.disabled || this.props.readOnly) return [];

		return (
			<Button
				{...submitButton}
				element="a"
				role='button'
				className="submit-button-grid"
                disabled={submitButton.disabled || this.state.waitingForAction || this.props.disabled || this.props.readOnly}
				onClick={(event) => {
					const fieldAPI = this.getFieldAPI();
					let idFirstFieldGrid = this.props.fields[0].id;

					if(!event.currentTarget.textContent.match("ATUALIZAR"))
						fieldAPI.fields(idFirstFieldGrid).focus();
					else{
						this.props.dataRows.forEach((item, key)=>{
							if(item.id === this.props.selectedRowId && document.querySelectorAll(`#${this.props.id}_edit`)[key])
								document.querySelectorAll(`#${this.props.id}_edit`)[key].focus();
						})
					}

					this.handleSubmitButtonClick(event)
				}}
			/>
		);
	}

	renderButtons() {
		return (
			<div className={this.themedClassName('form.buttonGroup')}>
				{this.renderOtherButtons()}
			    {this.renderSubmitButton()}
			</div>
		);
	}

	tabOrderLineGrid(){
		if($('.edit-line-grid').length > 0){ $('.button--flat').attr('tabindex', '0'); }
	}

    renderGrid() {
		setTimeout(() => {
            this.tabOrderLineGrid();
            const tableCell = $(".table-cell--text");
            if(tableCell.length > 0 && $(tableCell[0]).css('min-width') === '0px')
                this.calculateWidthTD();
        }, 1000);

        return (
			<Grid {...this.getGridProps()} />
		)
	}

    render() {
        return (
			<div className="grid-container">
				{this.renderButtons()}
				<div className={`grid-table-container ${this.className()}`}>
					{this.renderGrid()}
				</div>
			</div>
        );
    }
}
